"use client";
import { parseMarkdown } from "@padi/shared/policies/_utils/markdown";
import { useQuery } from "@tanstack/react-query";

export function DisplayMarkdown({
  id,
  content,
}: {
  id: string;
  content: string;
}) {
  const { data: html } = useQuery({
    queryKey: ["markdown", id],
    queryFn: () => parseMarkdown(content),
  });

  if (!html) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-4 bg-muted rounded w-3/4" />
        <div className="h-4 bg-muted rounded w-full" />
        <div className="h-4 bg-muted rounded w-5/6" />
        <div className="h-4 bg-muted rounded w-2/3" />
      </div>
    );
  }

  return (
    <div
      className="flex-1 overflow-y-auto px-1 py-4 prose prose-emerald prose-sm max-w-none prose-headings:text-primary prose-base prose-strong:text-foreground"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
